import { useMutation } from '@apollo/client';
import { useState, useEffect } from 'react';

import { LOGGED_IN_CARDS_PER_PAGE } from '../../config';
import { XcpDeleteCompanyRecommendationDocument } from '../../graphql/mutations/delete-company-recommendation.gql-types';
import { XcpRecommendedCompaniesDocument } from '../../graphql/queries/recommended-companies.gql-types';
import { useError } from '../use-error';

const updateDeleteRecommended = ({ companyId, mainPageData }: $TSFixMe) =>
  mainPageData?.viewer?.companiesRecommendations?.edges?.filter(
    ({ node }: $TSFixMe) => node.company.id !== companyId
  );

const useDeleteCompanyRecommendation = ({ setDeletedCompanies }: $TSFixMe) => {
  const [companyId, setCompanyId] = useState(null);
  // @ts-expect-error TS(2339) FIXME: Property 'showError' does not exist on type 'unkno... Remove this comment to see the full error message
  const { showError } = useError();

  useEffect(() => {
    if (companyId) handleDeleteRecommendation({ variables: { companyId } });
  }, [companyId]);

  const handleCache = ({ cache }: $TSFixMe) => {
    const mainPageData = cache.readQuery({
      query: XcpRecommendedCompaniesDocument,
      variables: { first: LOGGED_IN_CARDS_PER_PAGE },
    });

    const newMainPageData = {
      ...mainPageData,
      viewer: {
        ...mainPageData.viewer,
        companiesRecommendations: {
          ...mainPageData.viewer.companiesRecommendations,
          edges: updateDeleteRecommended({ companyId, mainPageData }),
        },
      },
    };

    cache.writeQuery({
      query: XcpRecommendedCompaniesDocument,
      variables: { first: LOGGED_IN_CARDS_PER_PAGE },
      data: {
        ...newMainPageData,
      },
    });
    setDeletedCompanies((state: $TSFixMe) => state + 1);
  };

  const [handleDeleteRecommendation] = useMutation(
    XcpDeleteCompanyRecommendationDocument,
    {
      update: (cache: $TSFixMe) => handleCache({ cache }),
      onError: (error: $TSFixMe) =>
        showError({ message: error.message, error }),
    }
  );

  return {
    handleDeleteRecommendation: (companyId: $TSFixMe) =>
      setCompanyId(companyId),
  };
};

export { useDeleteCompanyRecommendation };
